//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from './media-menu.html';

angular.module('curalate').component('mediaMenu', {
  template,
  controller: ['SessionVarsService', function(SessionVarsService) {
    this.isTrackedSourcesEnabled = SessionVarsService.isFeatureEnabled('tracked_source_management');
  }],
});
